import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { DateFormat, DEFAULT_DATE_FORMAT } from "../utils/DateUtils";

export interface AppState {
  initialised: boolean;
  APIEndpoint: string;
  APIEndpointProcessor: string;
  stripeKey: string;
  myUrl: string;
  loading: boolean;
  username?: string;
  authed: boolean;
  errorMessage?: string;
  user?: any;
  subscriptionActive: boolean;
  gridTheme: string;
  role: string;
  stripeId?: string;
  featureFlags?: string[];
  dateFormat: DateFormat;
}

const buildInitialState = (): AppState => {
  // Try to get the saved date format from localStorage
  const savedDateFormat = localStorage.getItem(
    "dateFormat"
  ) as DateFormat | null;

  const state: any = {
    initialised: false,
    loading: false,
    authed: false,
    subscriptionActive: false,
    role: "user",
    featureFlags: [],
    dateFormat: savedDateFormat || DEFAULT_DATE_FORMAT,
  };

  if (
    process.env.NODE_ENV === "dev" ||
    process.env.NODE_ENV === "development"
  ) {
    console.log("Dev environment");
    state.stripeKey =
      "pk_test_51PNC6qD102TPMwRfR398rDymChPOYuWJ9YiYdmw3Q1KjbK5Ug2GgQg2ghzaLVeQMSy6oF8zDpGiOF217b42CPm8T00Q5NINlm6";
  } else {
    state.stripeKey =
      "pk_live_51PNC6qD102TPMwRfO3f5E9H6NcfFxP4W2inE2NlS1X5KuVvQZOtSDUkYkUTwfW0zExYQB95xmKpP0zTeQNYlgkYU00p0BGXTcs";
  }

  return state;
};

// Create a separate atom just for the date format that will be stored in localStorage
export const DateFormatAtom = atomWithStorage<DateFormat>(
  "dateFormat",
  (localStorage.getItem("dateFormat") as DateFormat) || DEFAULT_DATE_FORMAT
);

// Main app state atom
export const AppStateAtom = atom<AppState>(buildInitialState());
